import { render } from "./InfoTwo.vue?vue&type=template&id=6ad2238e&scoped=true"
import script from "./InfoTwo.vue?vue&type=script&lang=js"
export * from "./InfoTwo.vue?vue&type=script&lang=js"

import "./InfoTwo.vue?vue&type=style&index=0&id=6ad2238e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad2238e"]])

export default __exports__